export function getView(beta) {
  return beta ? 'New' : 'Old'
}
